<script type="ts">
	import { dev } from '$app/env';

	import type { IThemedToken } from 'shiki';
	import TokenizedCode from './Code/TokenizedCode.svelte';
	export let code: IThemedToken[][] | string | JSON;
	export let tokens: IThemedToken[][] = [];

	// Check if code is json
	if (typeof code === 'string') {
		try {
			const parsedJSON = JSON.parse(code) as IThemedToken[][];
			code = parsedJSON;
		} catch (e) {
			if (dev) {
				console.info("[OK] Couldn't parse JSON. Example code is probably a string then.");
			}
		}
	}

	$: if (typeof code !== 'string') {
		tokens = code as IThemedToken[][];
	}
</script>

<pre class="code">
{#if tokens.length > 0}
		<TokenizedCode lines={tokens} />
	{:else if typeof code === 'string'}
		<code
			>{#each code.split('\n') as line}<div class="line">{line}</div>{/each}</code
		>
	{:else}
		<code>{code}</code>
	{/if}
</pre>
